export function setRoute({
  step_id,
  entity_index,
  onChange = () => {},
}: {
  step_id: string;
  entity_index: number;
  onChange?: (pathname: string) => void;
}): string {
  const newPathName = `/${step_id}/${entity_index}`;

  if (newPathName !== currentPathName()) {
    onChange(location.pathname);

    window.history.pushState(null, '', `/${step_id}/${entity_index}`);
  }

  return newPathName;
}

export function currentPathName(): string {
  return window.location.pathname;
}

export function getRouteStep(): { step_id?: string; entity_index?: number } {
  return getPathStep(currentPathName());
}

export function getPathStep(pathName: string): { step_id?: string; entity_index?: number } {
  if (pathName) {
    const [, step_id, entity_index] = pathName.split('/');

    if (step_id && entity_index) {
      try {
        return {
          step_id,
          entity_index: parseInt(entity_index),
        };
      } catch (error) {
        reportError({ error });
      }
    }
  }

  return { step_id: undefined, entity_index: undefined };
}
